export default "__VITE_ASSET__JwtwY6Xv__"